import { render } from "./Receive_button.vue?vue&type=template&id=6b2f1623&scoped=true"
import script from "./Receive_button.vue?vue&type=script&lang=js"
export * from "./Receive_button.vue?vue&type=script&lang=js"

import "./Receive_button.vue?vue&type=style&index=0&id=6b2f1623&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2f1623"]])

export default __exports__